import React from 'react';

export const STATUS_COLORS = {
	Excellent: { fg: '#065F46', bg: '#D1FAE5', ring: '#10B981' },
	Strong: { fg: '#1E40AF', bg: '#DBEAFE', ring: '#3B82F6' },
	Moderate: { fg: '#92400E', bg: '#FEF3C7', ring: '#F59E0B' },
	'Needs Attention': { fg: '#9A3412', bg: '#FFEDD5', ring: '#F97316' },
	Critical: { fg: '#9F1239', bg: '#FFE4E6', ring: '#F43F5E' },
};

function colorForScore(score) {
	if (score >= 85) return STATUS_COLORS.Excellent.ring;
	if (score >= 70) return STATUS_COLORS.Strong.ring;
	if (score >= 55) return STATUS_COLORS.Moderate.ring;
	if (score >= 35) return STATUS_COLORS['Needs Attention'].ring;
	return STATUS_COLORS.Critical.ring;
}

export default function ProgressCircle({ value = 0, size = 220, stroke = 18, label, sublabel, testId }) {
	const v = Math.max(0, Math.min(100, value));
	const radius = (size - stroke) / 2;
	const circ = 2 * Math.PI * radius;
	const dash = (v / 100) * circ;
	const color = colorForScore(v);
	return (
		<div className="relative inline-block" data-testid={testId}>
			<svg width={size} height={size} className="-rotate-90">
				<circle cx={size / 2} cy={size / 2} r={radius} stroke="#E2E8F0" strokeWidth={stroke} fill="none" />
				<circle
					className="score-arc"
					cx={size / 2}
					cy={size / 2}
					r={radius}
					stroke={color}
					strokeWidth={stroke}
					strokeLinecap="round"
					fill="none"
					strokeDasharray={`${dash} ${circ - dash}`}
				/>
			</svg>
			<div className="absolute inset-0 flex flex-col items-center justify-center">
				<div className="text-5xl font-heading font-bold text-slate-900 tabular-nums">{v}</div>
				{label && <div className="text-sm text-slate-500 mt-1">{label}</div>}
				{sublabel && <div className="text-xs font-bold uppercase tracking-[0.2em] mt-2" style={{ color }}>{sublabel}</div>}
			</div>
		</div>
	);
}
